module.exports = __webpack_public_path__ + "img/3.1120b8f5.png";